module.exports = __webpack_public_path__ + "img/health-banner-catalogue.158ecfa4.svg";